import { useState } from 'react';

const faqs = [
  {
    q: 'Wat kost het leggen van een PVC vloer?',
    a: 'De kosten voor het leggen van een PVC vloer variëren tussen €28 en €65 per m², afhankelijk van het type PVC (click of lijm), de oppervlakte en extra werkzaamheden zoals egalisatie of vloerverwarming. Een gemiddelde woonkamer van 40m² kost ongeveer €1.800 - €3.500 incl. materialen en leggen.',
  },
  {
    q: 'Hoelang duurt het leggen van een vloer?',
    a: 'Het leggen van een PVC vloer duurt gemiddeld 1 tot 3 dagen voor een appartement tot 60m². Grotere projecten of gietvloeren kunnen 3 tot 5 dagen duren. Dit is afhankelijk van de oppervlakte, eventuele egalisatie en of er oude vloer verwijderd moet worden.',
  },
  {
    q: 'Werken jullie met garantie op vloeren?',
    a: 'Ja, wij bieden standaard 15 jaar garantie op ons leggen. De PVC vloeren zelf hebben een fabrieksgarantie van 10 tot 25 jaar, afhankelijk van het merk en type. We bespreken alle garantievoorwaarden uitgebreid tijdens het adviesgesprek.',
  },
  {
    q: 'Kan ik zelf het type vloer en kleur kiezen?',
    a: 'Absoluut! Wij werken samen met diverse leveranciers zoals Moduleo, BerryAlloc en Quick-Step. U kunt kiezen uit honderden kleuren, patronen en houtlook designs. Onze adviseurs helpen u graag bij het maken van de juiste keuze op basis van uw interieur en gebruik.',
  },
  {
    q: 'Moet ik zelf voor afvoer van de oude vloer zorgen?',
    a: 'Nee, wij regelen de complete afvoer van uw oude vloer en alle afval. Dit is standaard inbegrepen in onze offerte. U hoeft zich hier geen zorgen over te maken.',
  },
  {
    q: 'Kunnen jullie ook vloerverwarming aanleggen?',
    a: 'Ja, wij leggen elektrische vloerverwarming onder PVC en laminaat vloeren. Dit is ideaal in combinatie met onze waterbestendige PVC vloeren. We adviseren u graag over de beste oplossing voor uw situatie.',
  },
  {
    q: 'Werken jullie ook in appartementen?',
    a: 'Ja, wij leggen vloeren in appartementen op dagelijkse basis. We nemen rekening met VvE-regels, geluidsnormen en de specifieke uitdagingen van appartementsgebouwen. Click PVC is hierbij zeer populair vanwege de geluidsdempende eigenschappen.',
  },
  {
    q: 'Hoe snel kan de vloer gelegd worden?',
    a: 'Na akkoord op de offerte kunnen we meestal binnen 1 tot 2 weken starten met het leggen. Dit is afhankelijk van de planning en beschikbaarheid van materialen. We communiceren altijd helder over de verwachte startdatum.',
  },
  {
    q: 'Moet ik mijn huis uit tijdens het leggen?',
    a: 'Nee, dat is meestal niet nodig. Het leggen van een vloer is relatief schoon werk en duurt meestal maar 1 tot 3 dagen. We dekken alles goed af en zorgen dat u gewoon thuis kunt blijven wonen tijdens het leggen.',
  },
  {
    q: 'Hoe bereid ik mijn huis voor op het leggen?',
    a: 'We adviseren u vooraf uitgebreid over de voorbereiding. Over het algemeen hoeft u alleen zorg te dragen voor het leegruimen van de te leggen ruimte (meubels eruit). Wij zorgen voor afdekking van andere ruimtes en bescherming van uw huis.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 sm:py-20 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-ink-900 mb-3 sm:mb-4">
            Veelgestelde vragen over <span className="font-medium text-brass-600">renovatie</span>
          </h2>
          <p className="text-sm sm:text-base text-ink-600">
            Alles wat u moet weten over PVC vloeren en het leggen ervan
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4">
          {faqs.map((faq, i) => {
            const open = openIndex === i;
            return (
              <div
                key={i}
                className={`border rounded-xl overflow-hidden transition-colors duration-200 ${
                  open ? 'border-brass-500' : 'border-gray-200 hover:border-brass-300'
                }`}
              >
                <button
                  onClick={() => setOpenIndex(open ? null : i)}
                  className="w-full px-4 sm:px-6 py-4 sm:py-5 text-left flex items-center justify-between bg-white hover:bg-gray-50 transition-colors cursor-pointer"
                >
                  <span className="font-semibold text-sm sm:text-base text-ink-900 pr-4">{faq.q}</span>
                  <i
                    className={`ri-arrow-down-s-line text-xl sm:text-2xl text-brass-600 flex-shrink-0 transition-transform duration-300 ${
                      open ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                <div
                  className="overflow-hidden transition-all duration-300"
                  style={{ maxHeight: open ? '300px' : '0' }}
                >
                  <div className="px-4 sm:px-6 py-4 sm:py-5 bg-gray-50 border-t border-gray-200">
                    <p className="text-sm sm:text-base text-ink-700 leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}